import {Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  templateUrl: './park-filter.html',
  selector: 'park-filter'
})
export class ParkFilterComponent {
  @Input() filters: [{ label: string, value: string }];
  @Output() public change = new EventEmitter();
  private _filters = [];

  public setFilter($event): void {
    // this.change.emit($event);
    /*
    if (!this.isFilterChecked(value)) {
      this._filters.push(value);
      this.change.emit(this._filters);
    }
    */
  }

  public isFilterChecked(value: string): boolean {
    return this._filters.includes(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/filter/park-filter.component.ts